var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    viewBox: "120 -838 720 718",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-120q-74.54 0-140.23-28.42-65.69-28.43-114.31-77.16-48.61-48.73-77.04-114.42Q120-405.69 120-480q0-137 89.77-239.23T440-838v49.23q-119.92 16.31-195.35 104.81-75.42 88.5-75.42 203.96 0 129.08 90.85 219.92 90.84 90.85 219.92 90.85 75.23 0 141.19-33.39 65.96-33.38 106.5-87.53L770.15-264q-51.69 68.08-126.69 106.04T480-120m330.62-218-42.47-24.62q10.54-23.23 16.58-53.73t6.04-63.65q0-117.77-76.96-205.88Q636.85-774 520-788.77V-838q135.08 12.69 227.54 116.08Q840-618.54 840-480q0 39.38-7.23 75.38T810.62-338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUsage);
export default __webpack_public_path__ + "static/media/data_usage.7cb63f2fd7e8304369bfe8598a3b1934.svg";
export { ForwardRef as ReactComponent };